module.exports = __webpack_public_path__ + "img/copy.7a74b73b.svg";